/* eslint-disable */
/* eslint-disable operator-linebreak */
import React from 'react';
import fallbackImageUrl from 'src/assets/empty_photo_benefit.jpg';
import { AlertAdapter } from 'pg-ui-library';

import { ICartBenefit } from 'src/interfaces';
import { useActions } from 'src/hooks/useActions';
import {
  useBenefitEnrollSelectionModalIsOpen,
  useSetBenefitEnrollSelectionModal,
  useSetBenefitType,
} from '../../enrollment.context';
import {
  AbsoluteIcon,
  CardContentContainer,
  CardContentTitle,
  CardImgContainer,
  EnrollCardSlot,
  EnrollmentChangesCardContainer,
  FallbackImg,
  IconCardSlot,
  WaiveCardSlot,
} from './styles';
import { benefitTypeAlias } from '../..';
import { useTypedSelector } from 'src/hooks/useTypedSelector';

const EnrollmentCardAddAction: React.FC<{
  type: string;
  blockerTypes: string[] | undefined;
  spouseMaxAge?: number;
  spouseAge?: number;
}> = ({ type, blockerTypes, spouseMaxAge, spouseAge }) => {
  const setSelectedBenefitType = useSetBenefitType();
  const isOpen = useBenefitEnrollSelectionModalIsOpen();
  const setIsOpen = useSetBenefitEnrollSelectionModal();
  const { cart } = useTypedSelector(state => state.benefits.data);

  const handleEnrollSelectionModal = () => {
    const maxAge = spouseMaxAge != null ? Number(spouseMaxAge) : null;
    const age = spouseAge != null ? Number(spouseAge) : null;

    if (maxAge != null && age != null && !isNaN(maxAge) && !isNaN(age) && age > maxAge) {
      AlertAdapter(`Spouse age is more than ${maxAge}. Benefits coverage plan is not applicable.`, 'warning');
      return;
    }

    const missingRequiredBenefits: string[] = [];
    setSelectedBenefitType(type);
    if (blockerTypes && blockerTypes.length > 0) {
      blockerTypes.forEach(blockerBenefit => {
        const isBenefitInCart = cart?.some(item => item.type === blockerBenefit && item.action === 'ADD');

        if (!isBenefitInCart) {
          missingRequiredBenefits.push(blockerBenefit);
        }
      });

      if (missingRequiredBenefits.length > 0) {
        AlertAdapter(
          'To enroll in this benefit, please ensure that the following benefits are in your cart: ' +
            missingRequiredBenefits.join(', '),
          'warning'
        );
        return;
      }
    }
    setIsOpen(!isOpen);
  };

  return (
    <EnrollCardSlot onClick={() => handleEnrollSelectionModal()}>
      <AbsoluteIcon>Enroll</AbsoluteIcon>
    </EnrollCardSlot>
  );
};

const EnrollmentCardRemoveAction: React.FC<{
  type: string;
  mandatory?: string;
}> = ({ type, mandatory }) => {
  const { addBenefitToCart } = useActions();
  const handleDecline = () => {
    if (mandatory === 'true') {
      AlertAdapter('Employee cannot waive this plan', 'error');
      return;
    }
    const declinedBenefit: ICartBenefit = {
      type: type || '',
      benefitId: '',
      imgURL: '',
      planDescription: type || '',
      optionDescription: 'Declined',
      price: 0,
      expiration: '',
      action: 'DECLINED',
      benefitName: type || '',
      benefitPlanId: '',
      benefitOptionId: '',
      benefitEnrollmentStart: '',
      benefitEnrollmentEnd: '',
      benefitProvider: '',
      employeeName: '',
      employeeCost: 0,
      employerName: '',
      employerCost: 0,
      percent: 0,
      fixedAmount: 0,
      dependents: '',
      employeeChoosesPayment: null,
      generalCategory: '',
    };
    addBenefitToCart({ ...declinedBenefit });

    AlertAdapter('You declined this option', 'success');
  };

  return (
    <WaiveCardSlot style={{ background: mandatory === 'true' ? '#ff9bade8' : '' }} onClick={handleDecline}>
      <AbsoluteIcon>Waive</AbsoluteIcon>
    </WaiveCardSlot>
  );
};

const EnrollmentChangesCard: React.FC<{
  type: string;
  imgURL?: string;
  mandatory?: string;
  blockerTypes?: string[] | undefined;
  spouseMaxAge?: number;
  spouseAge?: number;
}> = ({ type, imgURL, mandatory, blockerTypes, spouseMaxAge, spouseAge }) => {
  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    // eslint-disable-next-line no-param-reassign
    event.currentTarget.src = fallbackImageUrl;
  };

  return (
    <EnrollmentChangesCardContainer>
      <CardImgContainer>
        <FallbackImg src={imgURL ?? ''} alt="Fallback Image" onError={handleImageError} />
        <div style={{ marginBottom: '-50px', marginLeft: '-50%', display: 'flex' }}>
          <EnrollmentCardAddAction
            type={type}
            blockerTypes={blockerTypes}
            spouseMaxAge={spouseMaxAge}
            spouseAge={spouseAge}
          />
          <EnrollmentCardRemoveAction type={type} mandatory={mandatory} />
        </div>
      </CardImgContainer>
      <CardContentContainer>
        <CardContentTitle>{benefitTypeAlias(type)}</CardContentTitle>
      </CardContentContainer>
    </EnrollmentChangesCardContainer>
  );
};

export default EnrollmentChangesCard;
